import React from 'react';

import Edit from './edit/';
import GoalMemos from './memos/index';

class Item extends React.Component {
  render() {
    const { goal, isCurrentUser, user } = this.props;

    return (
      <div
        key={goal._id}
        className="o-box o-box--with-vertical-indent c-box u-display-flex u-align-items-center u-margin-bottom-small u-flex-column"
      >
        <Edit
          disabled={true}
          goal={goal}
          isCurrentUser={isCurrentUser}
          initialValues={{
            name: goal.name,
            status: goal.status === 'COMPLETED',
            dueAt: goal.dueAt,
          }}
          user={user}
          form={`goal-edit-${goal._id}`}
        />
        {user && <GoalMemos goal={goal} user={user} />}
      </div>
    );
  }
}
export default Item;



// WEBPACK FOOTER //
// ./src/goals/ListItem.js